const createObservableSubject = () => {
    let listeners = [];

    const subscribe = listener => {
        if (typeof listener !== 'function') {
            throw new Error('Expected listener to be a function.');
        }

        listeners.push(listener);

        return () => {
            listeners = listeners.filter(l => l !== listener);
        };
    };

    // eslint-disable-next-line no-restricted-syntax -- TODO: legacy forEach/switch (baseline)
    const notify = (...params) => listeners.forEach(listener => listener(...params));

    return {
        notify,
        subscribe
    };
};

export default createObservableSubject;
